import { styled } from '@mui/material/styles';
import { VpButton, VpHoverInfo } from '../../vp-ui';

const svgStyles = {
  height: '16px',
  width: '16px',
  padding: '0px'
};

export const StyledVpHover = styled(VpHoverInfo)(({ theme }) => ({
  color: theme.palette.vpColors.greyDark,
  ...svgStyles,
  svg: {
    color: theme.palette.vpColors.greyDark,
    ...svgStyles
  }
}));

export const StyleVpButtonSubmitResponse = styled(VpButton)({
  marginTop: '24px',
  width: '200px'
});

export const StyledBrandingButton = styled(VpButton, {
  shouldForwardProp: (prop) =>
    prop !== 'backgroundColor' || prop !== 'fontColor' || prop !== 'custom'
})(({ custom, backgroundColor, fontColor }) =>
  custom
    ? {
        opacity: 0.9,
        borderColor: backgroundColor === 'rgb(255 255 255 / 1)' ? '#000' : backgroundColor,
        backgroundColor,
        color: fontColor,
        '&:disabled': {
          opacity: 0.5,
          backgroundColor,
          color: fontColor
        },
        '&:hover': {
          opacity: 1,
          backgroundColor,
          color: fontColor
        }
      }
    : {}
);

export const StyledOutlineBrandingButton = styled(VpButton, {
  shouldForwardProp: (prop) => prop !== 'backgroundColor' || prop !== 'custom'
})(({ theme, custom, backgroundColor }) =>
  custom
    ? {
        opacity: 0.9,
        borderColor: backgroundColor === 'rgb(255 255 255 / 1)' ? '#000' : backgroundColor,
        color: backgroundColor === 'rgb(255 255 255 / 1)' ? '#000' : backgroundColor,
        '&:disabled': {
          opacity: 0.5,
          borderColor: backgroundColor,
          color: backgroundColor
        },
        '&:hover': {
          opacity: 1,
          borderColor: backgroundColor,
          color: backgroundColor === 'rgb(255 255 255 / 1)' ? '#000' : backgroundColor,
          backgroundColor: theme.palette.vpColors.white
        }
      }
    : {}
);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/styles.js